import { createAuthClient } from "better-auth/react";
import { usernameClient } from "better-auth/client/plugins";
import { notifyApiError } from "@/lib/api-error";
import { authUrl } from "@/lib/api-base";

const AUTH_TOKEN_KEY = "better-auth-token";

type AuthResultWithToken = {
  data?: {
    token?: string | null;
    user?: unknown;
  } | null;
} | null;

export function getAuthToken() {
  return localStorage.getItem(AUTH_TOKEN_KEY) ?? "";
}

export function setAuthToken(token: string) {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
}

export function clearAuthToken() {
  localStorage.removeItem(AUTH_TOKEN_KEY);
}

export function syncAuthTokenFromResult(result: AuthResultWithToken) {
  const token = result?.data?.token || getAuthToken();

  if (!token) {
    return { token: "", user: result?.data?.user };
  }

  setAuthToken(token);
  return { token, user: result?.data?.user };
}

export const authClient = createAuthClient({
  baseURL: authUrl(),
  plugins: [usernameClient()],
  fetchOptions: {
    auth: {
      type: "Bearer",
      token: getAuthToken
    },
    onResponse: async (context) => {
      const token = context.response.headers.get("set-auth-token");

      if (token) {
        setAuthToken(token);
      }

      if (!context.response.ok) {
        await notifyApiError(context.response);
      }
    }
  }
});
